export const prefixes = {
  NOTIFICATIONS: 'NOTIFICATIONS',
  API_ERROR: 'API_ERROR',
}
